// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import requestStatusEntity from './entities/request-status.json';
import requestStatusMenu from '../pages/request-status/menu.json';
import requestStatusFullForm from '../pages/request-status/forms/full.json';
import requestStatusContextForm from '../pages/request-status/forms/context.json';
import requestStatusMiniForm from '../pages/request-status/forms/mini.json';
import requestStatusLookupForm from '../pages/request-status/forms/lookup.json';
import requestStatusTableView from '../pages/request-status/views/table.json';
import requestStatusDashboardView from '../pages/request-status/views/dashboard.json';

/** Тип запису «Статус запиту» зі сторінками пакета: меню, форми та подання з pages/request-status/. */
export const requestStatusDefinition: IRecordTypeDefinition = {
  ...requestStatusEntity,
  views: assembleViewSet({
      table: requestStatusTableView,
      dashboard: requestStatusDashboardView,
  }),
  form: requestStatusFullForm,
  forms: { full: requestStatusFullForm, context: requestStatusContextForm, mini: requestStatusMiniForm, lookup: requestStatusLookupForm },
  menu: requestStatusMenu,
} as IRecordTypeDefinition;
